export default __webpack_public_path__ + "static/media/lp-01-exercise-03.dda7c8c7.jpg";